<div class="wrap">
  <div class="name">
    {{ label }}
    <span *ngIf="amount > 1" class="quantity">({{ amount }})</span>
  </div>
  <div class="price">
    <app-price-label
      [value]="price * amount | appCurrency | async"
      [noIcon]="true"
      [isCompact]="compactPrice"
    ></app-price-label>
  </div>
</div>
